import { render, staticRenderFns } from "./BestSells.vue?vue&type=template&id=b28f3196&scoped=true&"
import script from "./BestSells.vue?vue&type=script&lang=js&"
export * from "./BestSells.vue?vue&type=script&lang=js&"
import style0 from "./BestSells.vue?vue&type=style&index=0&id=b28f3196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28f3196",
  null
  
)

export default component.exports